import AdminSetupPage from "./AdminSetupPage";

export default AdminSetupPage;
